import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import authReducer from './_auth_reducer';
import loadReducer from './loadReducer';
import companyReducer from './company_reducer';
import platformReducer from './platformReducer';
import vacanciesReducer from './vacanciesReducer';
import jobsReducer from './jobsReducer';
import adminReducer from './adminReducer';
import usersReducer from './userReducer';
import applicantReducer from './applicantReducer';
import backendReducer from './backendReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      auth: authReducer,
      load: loadReducer,
      company: companyReducer,
      platform: platformReducer,
      vacancies: vacanciesReducer,
      jobs: jobsReducer,
      admin: adminReducer,
      users: usersReducer,
      applicant: applicantReducer,
      backend: backendReducer,
    }),
    composeEnhancers(applyMiddleware(thunk))
  );
  return store;
};
